import { WEBCHAT } from 'Constants/normalize-module';
import { healthSummarySchema } from 'Schemas/schemas';
import { API_HEALTH_SUMMARY, API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function healthSummaryRetrieve({ doctorId, summaryId }) {
  return {
    types: [
      ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_REQUESTED,
      ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_SUCCEED,
      ACTION_TYPES.HEALTH_SUMMARY_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/health-summaries/${summaryId}/`),
    options: {
      clientName: API_HEALTH_SUMMARY,
    },
    meta: {
      schema: {
        data: healthSummarySchema,
      },
      module: WEBCHAT,
    },
  };
}

export function healthSummaryCreate({ doctorId, body }) {
  return {
    types: [
      ACTION_TYPES.HEALTH_SUMMARY_CREATE_REQUESTED,
      ACTION_TYPES.HEALTH_SUMMARY_CREATE_SUCCEED,
      ACTION_TYPES.HEALTH_SUMMARY_CREATE_FAILED,
    ],
    promise: client => client.post(`/doctors/${doctorId}/health-summaries/`, body),
    options: {
      clientName: API_HEALTH_SUMMARY,
    },
    meta: {
      schema: {
        data: healthSummarySchema,
      },
      module: WEBCHAT,
    },
  };
}

export function healthSummaryUpdate({ doctorId, healthSummaryId, body }) {
  return {
    types: [
      ACTION_TYPES.HEALTH_SUMMARY_UPDATE_REQUESTED,
      ACTION_TYPES.HEALTH_SUMMARY_UPDATE_SUCCEED,
      ACTION_TYPES.HEALTH_SUMMARY_UPDATE_FAILED,
    ],
    promise: client =>
      client.patch(`/doctors/${doctorId}/health-summaries/${healthSummaryId}/`, body),
    options: {
      clientName: API_HEALTH_SUMMARY,
    },
  };
}

export function getSummaryConfig() {
  return {
    types: [
      ACTION_TYPES.HEALTH_SUMMARY_CONFIG_GET_REQUESTED,
      ACTION_TYPES.HEALTH_SUMMARY_CONFIG_GET_SUCCEED,
      ACTION_TYPES.HEALTH_SUMMARY_CONFIG_GET_FAILED,
    ],
    promise: client => client.get('/configs/summary'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function healthSummaryReset() {
  return {
    type: ACTION_TYPES.HEALTH_SUMMARY_RESET,
  };
}
